import {  sendApi } from ".";
import { T_Board } from "../model/boardModel";
import { T_Trouble } from "../model/troubleModel";

async function boardList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/board/list",
      data: {
        ...data,
      },
    });
    console.log(response)
    return response;
  }

async function boardInsert(data1?:T_Board){

  const response = await sendApi({
    method: "post",
    url: "/board/insert",
    isForm:true,
    data: {
      ...data1,
    },
  });

  console.log(response.data)
  return response;
}  

async function boardUpdate(data1?:T_Board){

  const response = await sendApi({
    method: "post",
    url: "/board/update",
    isForm:true,
    data: {
      ...data1,
    },
  });

  console.log(response.data)
  return response;
}  

async function boardDelete(data1?:T_Board){

  const response = await sendApi({
    method: "post",
    url: "/board/delete",
    data: {
      ...data1,
    },
  });
  return response;
}  


async function boardInfo(data1?:T_Board){

  const response = await sendApi({
    method: "post",
    url: "/board/info",
    data: {
      ...data1,
    },
  });
  return response;
}  

const board = {
    boardList,
    boardInsert,
    boardUpdate,
    boardDelete,
    boardInfo
  };
  export default board;

